var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"w-8 h-8 flex justify-center items-center arrow-box outline-none focus:outline-none",class:[
    _vm.type,
    {
      'h-14 w-14 bg-gray-400 bg-opacity-60 rounded-full':
        !_vm.isDesktop && _vm.type == 'white'
    }
  ],on:{"click":function($event){return _vm.$emit('click')}}},[_c('img',{attrs:{"src":_vm.imagePath(),"alt":"Exit"}})])}
var staticRenderFns = []

export { render, staticRenderFns }